import { NgModule } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { MaterialModule } from '@app/material.module';
@NgModule({
  imports: [MaterialModule],
})
export class IconModule {
  private path = 'assets/icons';
  constructor(
    private domSanitizer: DomSanitizer,
    public matIconRegistry: MatIconRegistry
  ) {
    this.matIconRegistry
      .addSvgIcon(`icon_Games`, this.setPath(`${this.path}/icon_jeux.svg`))
      .addSvgIcon(`icon_4`, this.setPath(`${this.path}/icon_jeux.svg`))
      .addSvgIcon(
        `icon_activities`,
        this.setPath(`${this.path}/icon_activite.svg`)
      )
      .addSvgIcon(
        `icon_Heritages`,
        this.setPath(`${this.path}/icon_patrimoine.svg`)
      )
      .addSvgIcon(`icon_0`, this.setPath(`${this.path}/icon_patrimoine.svg`))
      .addSvgIcon(
        `icon_agricultural`,
        this.setPath(`${this.path}/icon_patrimoine_agricole.svg`)
      )
      .addSvgIcon(
        `icon__4`,
        this.setPath(`${this.path}/icon_patrimoine_agricole.svg`)
      )
      .addSvgIcon(
        `icon_archeology`,
        this.setPath(`${this.path}/icon_patrimoine_archeologie.svg`)
      )
      .addSvgIcon(
        `icon__0`,
        this.setPath(`${this.path}/icon_patrimoine_archeologie.svg`)
      )
      .addSvgIcon(
        `icon_architecture`,
        this.setPath(`${this.path}/icon_patrimoine_architecture.svg`)
      )
      .addSvgIcon(
        `icon__3`,
        this.setPath(`${this.path}/icon_patrimoine_architecture.svg`)
      )
      .addSvgIcon(
        `icon_castle`,
        this.setPath(`${this.path}/icon_patrimoine_chateaux.svg`)
      )
      .addSvgIcon(
        `icon__19`,
        this.setPath(`${this.path}/icon_patrimoine_chateaux.svg`)
      )
      .addSvgIcon(
        `icon_culture`,
        this.setPath(`${this.path}/icon_patrimoine_culture.svg`)
      )
      .addSvgIcon(
        `icon__1`,
        this.setPath(`${this.path}/icon_patrimoine_culture.svg`)
      )
      .addSvgIcon(
        `icon_water`,
        this.setPath(`${this.path}/icon_patrimoine_eau.svg`)
      )
      .addSvgIcon(
        `icon__5`,
        this.setPath(`${this.path}/icon_patrimoine_eau.svg`)
      )
      .addSvgIcon(
        `icon_industrial`,
        this.setPath(`${this.path}/icon_patrimoine_industriel.svg`)
      )
      .addSvgIcon(
        `icon__18`,
        this.setPath(`${this.path}/icon_patrimoine_industriel.svg`)
      )
      .addSvgIcon(
        `icon_unusual`,
        this.setPath(`${this.path}/icon_patrimoine_insolite.svg`)
      )
      .addSvgIcon(
        `icon_Insolite`,
        this.setPath(`${this.path}/icon_patrimoine_insolite.svg`)
      )
      .addSvgIcon(
        `icon__null`,
        this.setPath(`${this.path}/icon_patrimoine_insolite.svg`)
      )
      .addSvgIcon(
        `icon_nature`,
        this.setPath(`${this.path}/icon_patrimoine_nature.svg`)
      )
      .addSvgIcon(
        `icon__2`,
        this.setPath(`${this.path}/icon_patrimoine_nature.svg`)
      )
      .addSvgIcon(
        `icon_religious`,
        this.setPath(`${this.path}/icon_patrimoine_religieux.svg`)
      )
      .addSvgIcon(
        `icon__6`,
        this.setPath(`${this.path}/icon_patrimoine_religieux.svg`)
      )
      .addSvgIcon(`icon_Events`, this.setPath(`${this.path}/icon_agenda.svg`))
      .addSvgIcon(`icon_3`, this.setPath(`${this.path}/icon_agenda.svg`))
      .addSvgIcon(
        `icon_circuit_16`,
        this.setPath(`${this.path}/icon_circuit_cheval.svg`)
      )
      .addSvgIcon(
        `icon_circuit_1`,
        this.setPath(`${this.path}/icon_circuit_pied.svg`)
      )
      .addSvgIcon(
        `icon_circuit_32`,
        this.setPath(`${this.path}/icon_circuit_trail.svg`)
      )
      .addSvgIcon(
        `icon_circuit_8`,
        this.setPath(`${this.path}/icon_circuit_velo.svg`)
      )
      .addSvgIcon(
        `icon_circuit_4`,
        this.setPath(`${this.path}/icon_circuit_vtc.svg`)
      )
      .addSvgIcon(
        `icon_circuit_2`,
        this.setPath(`${this.path}/icon_circuit_vtt.svg`)
      )
      .addSvgIcon(
        `icon_Circuits`,
        this.setPath(`${this.path}/icon_circuit.svg`)
      )
      .addSvgIcon(`icon_1`, this.setPath(`${this.path}/icon_circuit.svg`))
      .addSvgIcon(
        `icon_Services`,
        this.setPath(`${this.path}/icon_services.svg`)
      )
      .addSvgIcon(`icon_2`, this.setPath(`${this.path}/icon_services.svg`))
      .addSvgIcon(
        `icon_shop`,
        this.setPath(`${this.path}/icon_services_commerces.svg`)
      )
      .addSvgIcon(
        `icon_lodging`,
        this.setPath(`${this.path}/icon_services_hebergement.svg`)
      )
      .addSvgIcon(
        `icon_info`,
        this.setPath(`${this.path}/icon_services_info.svg`)
      )
      .addSvgIcon(
        `icon_restaurant`,
        this.setPath(`${this.path}/icon_services_restaurant.svg`)
      )
      .addSvgIcon(
        `icon_producteur_red`,
        this.setPath(`${this.path}/icon_producteur_red.svg`)
      )
      .addSvgIcon(
        `icon_producteur`,
        this.setPath(`${this.path}/icon_producteur_white.svg`)
      )
      .addSvgIcon(`twitter`, this.setPath(`${this.path}/twitter_blue.svg`))
      .addSvgIcon(`facebook`, this.setPath(`${this.path}/icon_fb.svg`))
      .addSvgIcon(`instagram`, this.setPath(`${this.path}/instagram.svg`))
      .addSvgIcon(
        `facebook2`,
        this.setPath(`${this.path}/f_Logo_CMYK-C_Blue.svg`)
      )
      .addSvgIcon(
        `facebook3`,
        this.setPath(`${this.path}/f_Logo_CMYK-C_red.svg`)
      )
      .addSvgIcon(`twitter2`, this.setPath(`${this.path}/twitter_red.svg`))
      .addSvgIcon(
        `google_store`,
        this.setPath(`${this.path}/icon_googleStore.svg`)
      )
      .addSvgIcon(`all-poi`, this.setPath(`${this.path}/header_icon_carte.svg`))
      .addSvgIcon(
        `inspiration`,
        this.setPath(`${this.path}/icon_item3_actif.svg`)
      )
      .addSvgIcon(`panorama`, this.setPath(`${this.path}/header_icon_360.svg`))
      .addSvgIcon(
        `pano_360`,
        this.setPath(`${this.path}/panorama/icon_360_360.svg`)
      )
      .addSvgIcon(
        `pano_divers`,
        this.setPath(`${this.path}/panorama/icon_360_divers.svg`)
      )
      .addSvgIcon(
        `pano_nature`,
        this.setPath(`${this.path}/panorama/icon_360_nature.svg`)
      )
      .addSvgIcon(
        `pano_heritage`,
        this.setPath(`${this.path}/panorama/icon_360_patrimoine.svg`)
      )
      .addSvgIcon(
        `pano_paysage`,
        this.setPath(`${this.path}/panorama/icon_360_paysage.svg`)
      )
      .addSvgIcon(
        `pano_town`,
        this.setPath(`${this.path}/panorama/icon_360_village.svg`)
      )
      .addSvgIcon(
        `circuit_difficulty_1`,
        this.setPath(`${this.path}/icon_circuit_difficulte1.svg`)
      )
      .addSvgIcon(
        `circuit_difficulty_2`,
        this.setPath(`${this.path}/icon_circuit_difficulte2.svg`)
      )
      .addSvgIcon(
        `circuit_difficulty_3`,
        this.setPath(`${this.path}/icon_circuit_difficulte3.svg`)
      )
      .addSvgIcon(
        `circuit_difficulty_4`,
        this.setPath(`${this.path}/icon_circuit_difficulte4.svg`)
      )
      .addSvgIcon(
        `circuit_difficulty_1-red`,
        this.setPath(`${this.path}/icon_circuit_difficulte1-red.svg`)
      )
      .addSvgIcon(
        `circuit_difficulty_2-red`,
        this.setPath(`${this.path}/icon_circuit_difficulte2-red.svg`)
      )
      .addSvgIcon(
        `circuit_difficulty_3-red`,
        this.setPath(`${this.path}/icon_circuit_difficulte3-red.svg`)
      )
      .addSvgIcon(
        `circuit_difficulty_4-red`,
        this.setPath(`${this.path}/icon_circuit_difficulte4-red.svg`)
      );
  }
  private setPath(url: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
